module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"creating":"AI生成中..."},"en":{"creating":"Executing your command.."}}')
  delete Component.options._Ctor
}
